/** @jsx jsx */
// eslint-disable-next-line no-unused-vars
import React, { useState } from 'react'
import { Popover, PopoverTrigger, PopoverContent, Stack } from '@chakra-ui/react'
import { Grid, Heading, Box } from '@theme-ui/components'
import { MdPhoneInTalk } from 'react-icons/md'
import { TiDocumentText } from 'react-icons/ti'
import { jsx } from 'theme-ui'
import { NavLink } from './NavLink'
import { Button, ALink, PopMenuItem } from '../elements'
import PreviewCompatibleImg from '../PreviewCompatibleImage'

const MenuPopper = ({ item }) => {
  const hasChildren = item.childItems.nodes && item.childItems.nodes.length > 0
  const imageDefault =
    hasChildren && item.childItems.nodes.filter(node => node.menuImage)[0].menuImage.image
  const [state, setState] = useState({
    rightPanelItems: null,
    image: imageDefault,
  })
  if (!hasChildren) return <NavLink {...item} />
  return (
    <Popover trigger="hover" placement="bottom">
      <PopoverTrigger>
        <PopMenuItem
          sx={{
            display: 'block',
            color: 'black',
            fontSize: 18,
            padding: '16px',
          }}
          to="#"
        >
          {item.label}
        </PopMenuItem>
      </PopoverTrigger>

      <PopoverContent
        sx={{
          border: '0',
          zIndex: '100',
          bg: 'secondary',
          color: 'white',
          width: '100%',
          maxWidth: '100%',
          transformOrigin: '0% 0% !important',
          transform: 'none',
        }}
      >
        <Box sx={{ position: 'relative', px: 4, py: 3, width: '100%' }}>
          <Grid columns={3}>
            <Box sx={{ width: 1, bg: 'gray', height: 400 }}>
              {state.image !== null && (
                <PreviewCompatibleImg
                  image={state.image}
                  sx={{ height: '100%', objectFit: 'cover' }}
                />
              )}
            </Box>
            <Box sx={{ px: 5 }}>
              <Heading as="h2" sx={{ fontSize: 4, my: 2 }}>
                {item.label}
              </Heading>
              <hr />
              <Stack sx={{ ml: 2 }}>
                {hasChildren &&
                  item.childItems.nodes.map((child, i) => (
                    <NavLink
                      // eslint-disable-next-line react/no-array-index-key
                      key={i}
                      sx={{
                        color: 'white',
                        ':hover': { background: 'white', color: 'primary' },
                        my: 1,
                        p: 2,
                      }}
                      {...child}
                      onMouseEnter={() => {
                        setState({
                          ...state,
                          rightPanelItems:
                            child.childItems.nodes.length > 0 ? child.childItems.nodes : null,
                          image: (child.menuImage && child.menuImage.image) || state.image,
                        })
                      }}
                    />
                  ))}
              </Stack>
            </Box>
            {!state.rightPanelItems ? (
              <Box sx={{ 'a, a button': { width: '100%', my: 3 } }}>
                <a href="tel:410-752-7663">
                  <Button
                    sx={{
                      alignItems: 'center',
                      display: 'flex',
                      ':hover': { color: 'white' },
                      bg: 'primary',
                      fontSize: 4,
                    }}
                  >
                    <MdPhoneInTalk sx={{ mr: [2] }} />
                    <p>Call Now 410-752-7663</p>
                  </Button>
                </a>
                <ALink to="/contact">
                  <Button
                    sx={{
                      alignItems: 'center',
                      display: 'flex',
                      ':hover': { color: 'white' },
                      bg: 'black',
                      fontSize: 4,
                    }}
                  >
                    <TiDocumentText sx={{ mr: [2] }} />
                    REQUEST A FREE ESTIMATE
                  </Button>
                </ALink>
              </Box>
            ) : (
              <Stack sx={{ pt: 3 }}>
                {state.rightPanelItems.map((child, i) => (
                  <NavLink
                    // eslint-disable-next-line react/no-array-index-key
                    key={i}
                    sx={{
                      color: 'white',
                      ':hover': { background: 'white', color: 'primary' },
                      p: 2,
                    }}
                    {...child}
                  />
                ))}
              </Stack>
            )}
          </Grid>
        </Box>
      </PopoverContent>
    </Popover>
  )
}
export { MenuPopper }
